import { EmobilityDeviceState } from '@store/types';

export const initialState: EmobilityDeviceState = {
    error: false,
    loading: false,
    electricCar: undefined,
    chargingModes: {
        data: [],
        error: false,
        loading: true,
    },
    chargingHistory: {
        data: null,
        error: false,
        loading: true,
    },
    firmware: {
        updateSettings: {
            error: false,
            data: { auto: false },
        },
    },
    chargingSurplusTolerance: null,
};
